import { Component, OnInit } from '@angular/core';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatChipsModule } from '@angular/material/chips';
import { NgToastService } from 'ng-angular-popup';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { CommonModule } from '@angular/common';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { Router, ActivatedRoute } from '@angular/router';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { DomSanitizer } from '@angular/platform-browser';
import { BriefSectionComponent } from '@/app/components/projects/project-development/tendering/project-expression-of-interest/brief-section/brief-section.component';
import { MatDialog } from '@angular/material/dialog';
import { RfiService } from '@/app/services/rfi/rfi.service';
import { CommentsComponent } from '../../comments/comments.component';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DatePipe } from '@angular/common';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';
import { environment } from '@/app/environments/environment';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';

export enum enumMessages {
  SentToClientSuccess = 'Sent to client successfully',
}

@Component({
  standalone: true,
  imports: [
    MatChipsModule,
    MatButtonModule,
    MatSelectModule,
    ReactiveFormsModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    BriefSectionComponent,
    CommentsComponent,
    MatCheckboxModule,
  ],
  selector: 'app-contractor-rfi-view',
  templateUrl: './contractor-rfi-view.component.html',
  styleUrls: ['./contractor-rfi-view.component.css'],
  providers: [DatePipe],
})
export class ContractorRfiViewComponent implements OnInit {
  projectId: any;
  rfiId: any;
  projectName: string;
  projectIdentifier: any;
  isEdit: boolean = false;
  sendApprovals: boolean = false;
  rfiInfo: any;
  org_info: any = localStorage.getItem('org_info')
    ? JSON.parse(localStorage.getItem('org_info') as string)
    : null;
  docUrl: string | null = null;
  constructor(
    private toast: NgToastService,
    private tenderingService: TenderingService,
    private sanitizer: DomSanitizer,
    private projectsService: ProjectsService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private rfiService: RfiService,
    private getFileIconService: GetFileIconUtilityService,
    private datePipe: DatePipe,
    private http: HttpClient
  ) {}

  ngOnInit(): void {
    this.projectId = this.activatedRoute.snapshot.paramMap.get('projectId')!;
    this.rfiId = this.activatedRoute.snapshot.paramMap.get('rfiId')!;
    this.activatedRoute.queryParams.subscribe((params) => {
      this.projectName = params['projectName'];
      this.projectIdentifier = params['projectIdentifier'];
    });

    this.fetchRfiInfo();
  }

  fetchRfiInfo(): any {
    return this.rfiService.getContractorRfiInfo(this.rfiId).subscribe({
      next: (response: any) => {
        if (response?.meta?.success) {
          this.rfiInfo = response?.data;
        }
      },
      error: (error) => {
        console.error('Error fetching projects:', error);
      },
    });
  }

  async sendToClient() {
    this.rfiService.sendToClient(this.rfiId).subscribe({
      next: (response: any) => {
        console.log('Response:', response);
        if (response?.meta?.success) {
          this.toast.success(enumMessages.SentToClientSuccess, 'SUCCESS', 4000);
          this.handleClose();
        }
      },
      error: (error: any) => {
        console.error('Login failed:', error);
        this.toast.danger(error.error.data, 'DANGER', 4000);
      },
    });
  }

  handleClose() {
    this.router.navigate(['/rfi-listing'], {
      queryParams: {
        projectName: this.projectName,
        projectIdentifier: this.projectIdentifier,
      },
    });
  }

  handleEdit(selectedEoiId) {
    this.tenderingService.setProjectIdentifier(this.projectIdentifier);
    this.tenderingService
      .getEOICurrentStageData(this.projectId, selectedEoiId)
      .subscribe({
        next: (response: any) => {
          if (response?.data) {
            // this.savedEOIData = response.data;
          }
        },
        error: (error: any) => {
          console.error('Failed to fetch:', error);
        },
      });
    this.isEdit = !this.isEdit;
    this.tenderingService.setEditState(this.isEdit);
  }

  handleDialog() {
    this.isEdit = false;
    this.fetchRfiInfo();
  }

  async getRfiApprovalsStatus(): Promise<void> {
    try {
      const response = await this.projectsService
        .getApprovalsStatus(this.projectId, this.rfiId, 'rfi')
        .toPromise();
      console.log('Approvals status:', response);
    } catch (error) {
      console.error('Error approvals status:', error);
    }
  }
  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }
  togglePermission(response: any) {
    // Toggle logic here
    console.log('Toggled:', response);
  }
  deleteResponse(response: any) {
    // this.responses = this.responses.filter((r) => r !== response);
    console.log('Deleted:', response);
  }
  getFileIcon(name: string): string {
    const file: any = {
      name,
    };
    return this.getFileIconService.getFileIcon(file);
  }
  formatDate(dateString: string): string {
    return this.datePipe.transform(dateString, "MMM d, y 'at' h:mm a") || '';
  }
  downloadDocuments(
    event: Event,
    downloadLink: HTMLAnchorElement,
    id: number,
    filePath: string
  ): void {
    event.preventDefault();

    const parts = filePath.split('/');
    const _filePath = parts[parts.length - 1];

    const apiUrl = environment.apiUrl;
    const fullPath = `${apiUrl}/projects/${this.projectId}/tendering/rfp/${this.rfiId}/clarifications/download/documents/${id}/${_filePath}`;

    const href = downloadLink.getAttribute('href');
    console.log('href:', href);
    if (href !== '#') {
      console.log('The download is already in progress');
      return;
    }

    // Fetch the image from the backend
    this.http
      .post(fullPath, {}, { responseType: 'blob' })
      .pipe(take(1))
      .subscribe({
        next: (blob: Blob) => {
          if (!(blob instanceof Blob)) {
            console.error('Received invalid blob response');
            return;
          }

          const docUrl = URL.createObjectURL(blob);

          window.open(docUrl, '_blank');

          setTimeout(() => URL.revokeObjectURL(docUrl), 5000);
        },
        error: (error) => {
          console.error('Error downloading document:', error);
        },
      });
  }
}
